<app-loading *ngIf="contentReady"></app-loading>
@if (noData) {
<app-nodata></app-nodata>
} @else {
<div [ngClass]="{
    'bg-light': isFullPage
  }" [ngStyle]="{
    'margin-bottom': isFullPage ? '80px' : '0'
  }">

  <div [ngClass]="{
    'container': isFullPage
  }">
    <div [ngClass]="{
    'row justify-content-center': isFullPage
  }">
      <div class="row" [ngStyle]="{
    'margin-top': isFullPage ? '80px' : '0'
  }" style="padding: 0;">

        <div class="col-6">
          <h4> {{"daily_offer"| transloco }}</h4>
        </div>
        <div class="col-6 text-align" style="margin-top: 5px;">
          <p>{{stockTotal}} {{"Product"| transloco }}</p>
        </div>
        <app-product *ngFor="let element of allData" class="col-6 col-md-4 pointer" [element]="element"
          [isAr]="isAr"></app-product>
      </div>
    </div>
    @if(isFullPage){
    <app-shoping style="padding: 0!important;"></app-shoping>
    <app-producthotdeals style="padding: 0;" *ngIf="allData.length != 0"></app-producthotdeals>

    }
  </div>
</div>

}